export type Config = {
    companyName: string;
};

export const config: Config = {
    companyName: 'ACME',
};
